import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class LmSelect extends React.Component {

  componentDidMount() {
    lmSelectLib(this.element, this.props.onchange);
  }

  render() {
    const {list, selected} = this.props;

    return (
      <div className="lm-select typography_t1" ref={i => this.element = i}>
        <span className="lm-select-ico"></span>
        <div className="lm-select-value">&nbps;</div>
        <div className="lm-select-options">
          <div className="lm-select-list">
            {list.map((v, k) =>
              <div key={k} data-value={v.key} className={classNames('lm-select-item', {'lm-select-selected': v.key === selected})}>{v.title}</div>
            )}
          </div>
        </div>
        <div className="lm-select-overflow"></div>
      </div>
    );
  }
}

LmSelect.propTypes = {
  onchange: PropTypes.func,
  list: PropTypes.array.isRequired,
  selected: PropTypes.string
};

export default LmSelect;


/**
 * Like material select
 * @author vidmantasz @ wix.com
 * @select html element
 * @onChange callback
 */
function lmSelectLib(select, onChange) {
  const selectValue = select.querySelector('.lm-select-value');
  const options = select.querySelector('.lm-select-options');
  const list = select.querySelector('.lm-select-list');
  const items = select.querySelectorAll('.lm-select-item');
  const overflow = select.querySelector('.lm-select-overflow');
  const scrollContainer = window.document.querySelector('.ln-scroll-inner');

  function selectItem(selected, isUpdate) {
    const value = selected.getAttribute('data-value') || selected.textContent;
    selected.classList.add('lm-select-selected');
    selectValue.textContent = selected.textContent;
    selectValue.setAttribute('data-value', value);
    if (onChange && isUpdate) {
      onChange(getData());
    }
  }

  function getData() {
    return {text: selectValue.textContent, value: selectValue.getAttribute('data-value')};
  }

  function hideSelect() {
    select.classList.remove('lm-select-active');
    removeDScroll();
    setTimeout(() => {
      select.classList.remove('lm-select-animating');
    }, 400);
  }

  function handleChange(event) {
    const old = select.querySelector('.lm-select-selected');
    if (old) {
      old.classList.remove('lm-select-selected');
    }

    selectItem(event.target, true);
    hideSelect();
  }

  function handleOpen() {
    setDScroll();
    const selected = select.querySelector('.lm-select-selected');
    select.classList.add('lm-select-animating');
    const scrollTop = (selected.offsetTop + (selected.offsetHeight / 2)) - (list.offsetHeight / 2);
    list.scrollTop = Math.max(0, scrollTop);
    const listTop = Math.min(select.offsetTop - 10, selected.offsetTop - list.scrollTop) * -1;
    options.style.top = listTop + 'px';

    window.setTimeout(() => {
      select.classList.add('lm-select-active');
    }, 10);
  }

  function setDScroll() {
    scrollContainer.classList.add('ln-scroll-disable');
  }

  function removeDScroll() {
    scrollContainer.classList.remove('ln-scroll-disable');
  }

  selectItem(select.querySelector('.lm-select-selected') ||
    select.querySelector('.lm-select-item'));

  selectValue.addEventListener('click', handleOpen);

  for (let i = 0, l = items.length; i < l; i++) {
    items[i].addEventListener('click', handleChange);
  }

  overflow.addEventListener('click', hideSelect);

  return {
    get: getData
  };
}



// WEBPACK FOOTER //
// ./components/Lm-select.js